import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'

import { Icon } from '@/components/ui/Icon'
import { cn } from '@/lib/cn'

/** Заголовок экрана: название, подпись, кнопки справа, ссылка «назад» на телефоне. */
export function PageHeader({
  title,
  description,
  actions,
  back,
  className,
}: {
  title: ReactNode
  description?: ReactNode
  actions?: ReactNode
  back?: { to: string; label: string }
  className?: string
}) {
  return (
    <header className={cn('mb-4 flex flex-wrap items-end gap-x-4 gap-y-2 lg:mb-6', className)}>
      {/* Основа 16rem: на узком экране кнопки уходят на строку ниже, а не сжимают текст в столбик. */}
      <div className="min-w-0 flex-[1_1_16rem]">
        {back ? (
          <Link
            to={back.to}
            className="-ml-1 mb-1 inline-flex min-h-11 items-center gap-1 text-sm text-muted hover:text-fg lg:min-h-8"
          >
            <Icon name="chevron-left" size={18} />
            {back.label}
          </Link>
        ) : null}
        <h1 className="text-xl font-semibold tracking-tight text-fg lg:text-2xl">{title}</h1>
        {description ? <p className="mt-1 text-sm text-muted">{description}</p> : null}
      </div>
      {actions ? <div className="flex max-w-full shrink-0 flex-wrap items-center gap-2">{actions}</div> : null}
    </header>
  )
}
